import { action, computed, makeObservable, observable } from 'mobx';
import { IWindowController, WindowController } from './WindowController';

interface IWindowCollection<D extends Record<string, any> = {}> {
  list: Map<string, IWindowController<D>>;
  open(id: string, data: D): void;
  close(id: string): void;
}

/** Сущность для управления множеством окон */
export class WindowCollection<D extends Record<string, any> = {}>
  implements IWindowCollection<D>
{
  @observable protected _list: Map<string, IWindowController<D>> = new Map();

  constructor() {
    makeObservable<WindowCollection<D>>(this);
  }

  @computed get list() {
    return this._list;
  }

  /** Создаёт новое окно и разворачивает его */
  @action open = (id: string, data: D) => {
    const window = new WindowController({ data, defaultVisible: true });

    this._list.set(id, window);
  };

  @action close = (id: string) => {
    this._list.delete(id);
  };
}
